import { createFeatureSelector, createSelector } from "@ngrx/store";
import { Customer, CustomersData } from "../../interfaces";
import { CustomersDataFeatureName } from "./customers.reducer";

export const CustomersDataFeatureSelector =
    createFeatureSelector<CustomersData>(CustomersDataFeatureName);

const getIsLoading = ({ isLoading }: CustomersData): boolean => isLoading;

const getCustomers = ({ customers }: CustomersData): Customer[] => customers;

const getSelectedCustomer = ({ selectedCustomer }: CustomersData): Customer | null => selectedCustomer;

export const isCustomersLoading = createSelector(
    CustomersDataFeatureSelector,
    getIsLoading
);

export const customers = createSelector(
    CustomersDataFeatureSelector,
    getCustomers
);

export const selectedCustomer = createSelector(
    CustomersDataFeatureSelector,
    getSelectedCustomer
);